var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import gql from "graphql-tag";
import { Query as QueryComponent } from "@irati/utils/services/apollo";
import { RewardStatus } from "@irati/reward/enums";
import RewardCatalogueProduct from "./fragments/RewardCatalogueProduct";
var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query RewardCatalogueRewards($limit: Int, $q: String, $offset: Int, $status: String, $locale: String, $rewardsForMyPackage: Boolean) {\n    rewardCatalogueRewards(\n      limit: $limit\n      q: $q\n      offset: $offset\n      status: $status\n      locale: $locale\n      rewardsForMyPackage: $rewardsForMyPackage\n    ) {\n      count\n      limit\n      offset\n      total\n      results {\n        uuid\n        archived\n        internalIdentifier\n        urlSlug\n        status\n        header\n        description\n        importantInfo\n        deliveryInfo\n        redemptionInstructions\n        termsAndConditions\n        bannerImage\n        cardImage\n        thumbnailImage\n        keywords\n        locale\n        country\n        products {\n          count\n          total\n          results {\n            ...RewardCatalogueProduct\n          }\n        }\n        tags {\n          uuid\n          name\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query RewardCatalogueRewards($limit: Int, $q: String, $offset: Int, $status: String, $locale: String, $rewardsForMyPackage: Boolean) {\n    rewardCatalogueRewards(\n      limit: $limit\n      q: $q\n      offset: $offset\n      status: $status\n      locale: $locale\n      rewardsForMyPackage: $rewardsForMyPackage\n    ) {\n      count\n      limit\n      offset\n      total\n      results {\n        uuid\n        archived\n        internalIdentifier\n        urlSlug\n        status\n        header\n        description\n        importantInfo\n        deliveryInfo\n        redemptionInstructions\n        termsAndConditions\n        bannerImage\n        cardImage\n        thumbnailImage\n        keywords\n        locale\n        country\n        products {\n          count\n          total\n          results {\n            ...RewardCatalogueProduct\n          }\n        }\n        tags {\n          uuid\n          name\n        }\n      }\n    }\n  }\n  ", "\n"])), RewardCatalogueProduct);
export var variables = {
    limit: 20,
    offset: 0,
    q: null,
    status: RewardStatus.ON
};
var RewardCatalogueRewardsQuery = /** @class */ (function (_super) {
    __extends(RewardCatalogueRewardsQuery, _super);
    function RewardCatalogueRewardsQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardCatalogueRewardsQuery.prototype.render = function () {
        return React.createElement(QueryComponent, __assign({ query: query }, this.props));
    };
    RewardCatalogueRewardsQuery.defaultProps = {
        variables: variables
    };
    return RewardCatalogueRewardsQuery;
}(PureComponent));
export default RewardCatalogueRewardsQuery;
var templateObject_1;
